export enum Status {
  None,
  Created,
  InProgress,
  Completed,
  Failed,
  Cancelled,
}
